import React from "react";
import { useNavigate } from "react-router-dom";
import { Settings2, LogOut, X, User, Crosshair, UserCog } from "lucide-react";

const LEAD_HUNTER_URL = "https://ai.studio/apps/8a2535e8-9f39-4b8a-a8fc-8c61528686ad?fullscreenApplet=true";

export function MobileMenuSheet({ profile, onClose, onLogout }) {
  const navigate = useNavigate();
  const userInitial = profile?.first_name?.[0]?.toUpperCase() || profile?.email?.[0]?.toUpperCase() || "A";

  const go = (path) => { onClose(); navigate(path); };

  return (
    <div className="md:hidden fixed inset-0 z-[60] flex flex-col justify-end bg-black/60" onClick={onClose}>
      <div className="bg-[#111] border-t border-white/10 rounded-t-3xl p-6 flex flex-col gap-3 animate-fadeInUp" onClick={e => e.stopPropagation()}>
        <div className="flex items-center gap-3 pb-3 border-b border-white/10 mb-1">
          <div className="w-11 h-11 rounded-full overflow-hidden border-2 border-[#ffc700]/30 flex items-center justify-center bg-gradient-to-br from-[#ffc700] to-[#ff8c00]">
            {profile?.avatar
              ? <img src={profile.avatar} alt="avatar" className="w-full h-full object-cover" />
              : <span className="text-black text-base font-black">{userInitial}</span>
            }
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-bold text-white truncate">{profile?.first_name || "Admin"}</p>
            <p className="text-xs text-gray-500 truncate">{profile?.email || ""}</p>
          </div>
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-white"><X size={20} /></button>
        </div>

        <button onClick={() => go("/profile")} className="flex items-center gap-3 py-3 px-4 rounded-xl bg-white/5 text-white font-semibold text-sm">
          <User size={18} className="text-[#ffc700]" /> Mi Perfil
        </button>
        <button onClick={() => go("/accounts")} className="flex items-center gap-3 py-3 px-4 rounded-xl bg-white/5 text-white font-semibold text-sm">
          <UserCog size={18} className="text-[#ffc700]" /> Cuentas de Clientes
        </button>
        <a href={LEAD_HUNTER_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 py-3 px-4 rounded-xl bg-white/5 text-white font-semibold text-sm">
          <Crosshair size={18} className="text-[#ffc700]" /> Lead Hunter
        </a>
        <button onClick={() => go("/settings")} className="flex items-center gap-3 py-3 px-4 rounded-xl bg-white/5 text-white font-semibold text-sm">
          <Settings2 size={18} className="text-[#ffc700]" /> Configuración
        </button>
        <button onClick={() => { onClose(); onLogout(); }} className="flex items-center gap-3 py-3 px-4 rounded-xl bg-red-500/10 text-red-400 font-semibold text-sm mt-1 border border-red-500/20">
          <LogOut size={18} /> Cerrar sesión
        </button>
      </div>
    </div>
  );
}
